<template>
  <div class="subs-wrap" v-if="!$route.params.slug">
    <div class="mb-2 subs-head">
      <a-input v-model:value="searchValue" class="search-input" :placeholder="$t('search')">
        <template #prefix>
          <search-outlined class="search-icon" />
        </template>
      </a-input>
      <div class="btns-wrap">
        <a-button @click="addSupplierHandler" size="large" type="primary"><plus-outlined />{{ $t('add') }}</a-button>
        <a-button @click="exportData" size="large">{{ $t('export') }}</a-button>
      </div>
    </div>

    <a-table
        :columns="columns"
        :data-source="filteredData"
        :pagination="{ ...pagination, locale: paginationLocale }"
        :customRow="customRow"
        :show-header="!isMobileView"
        :loading="loading"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'action'">
          <a-dropdown trigger="click">
            <a-button shape="circle" class="more-btn" @click.stop="handleActionClick(record)">
              <more-outlined />
            </a-button>
            <template #overlay>
              <a-menu>
                <a-menu-item @click="deleteHandler" key="1"><delete-outlined /> {{ $t('delete') }}</a-menu-item>
              </a-menu>
            </template>

          </a-dropdown>
        </template>
        <template v-if="column.key === 'all'">
          <a-card :title="$t('user')" class="table-card">
            <p class="user-card-row">
              <span>
                {{$t('supplier')}}
              </span>
              <span>{{record.name}}</span>
            </p>
            <p class="user-card-row">
              <span>
                IČO
              </span>
              <span>
                {{record.ico}}
              </span>
            </p>
            <p class="user-card-row">
              <span>
                DIČ
              </span>
              <span>
                {{record.dic}}
              </span>
            </p>
            <p class="user-card-row">
              <span>
                {{$t('residence')}}
              </span>
              <span>{{record.address}}</span>
            </p>

            <p class="user-card-row">
              <span>
                {{$t('actions')}}
              </span>
              <span>
                <a-dropdown trigger="click">
                  <a-button shape="circle" class="more-btn" @click.stop="handleActionClick(record)">
                    <more-outlined />
                  </a-button>
                  <template #overlay>
                    <a-menu>
                      <a-menu-item @click="deleteHandler" key="1"><delete-outlined /> {{ $t('delete') }}</a-menu-item>
                    </a-menu>
                  </template>

                </a-dropdown>
              </span>
            </p>
          </a-card>
        </template>
      </template>
    </a-table>
    <CompanyModal
        :company="supplier"
        :userTypePrefix="'sup'"
        :show-modal="showAddModal"
        @close="handleCancelAdd"
        @update="handleOkAdd($event)"
    ></CompanyModal>
    <DeleteSModal
        :title="$t('modal-titles.delete-sup')"
        :company="selectedSup"
        :show-modal="showDeleteSubModal"
        @close="handleCancelDelete"
        @delete="handleOkDelete"
    ></DeleteSModal>
    <ContactModal
        v-if="showContactModal"
        :contact="contact"
        :show-modal="showContactModal"
        @close="handleCloseContact"
        @update="handleOkContact($event)"
    ></ContactModal>
  </div>
  <router-view v-else />

</template>

<script>
import {
  MoreOutlined,
  SearchOutlined,
  DeleteOutlined,
  PlusOutlined
} from "@ant-design/icons-vue";
import DeleteSModal from "@/components/Modals/DeleteSModal";
import CompanyModal from "@/components/Modals/Company";
import ContactModal from "@/components/Modals/ContactModal";
import {notification} from "ant-design-vue";

export default {
  components: {
    MoreOutlined,
    SearchOutlined,
    DeleteOutlined,
    PlusOutlined,
    DeleteSModal,
    CompanyModal,
    ContactModal
  },
  data() {
    return {
      searchValue: '',
      showContactModal: false,
      user: JSON.parse(localStorage.getItem('user')),
      showAddModal: false,
      showDeleteSubModal: false,
      selectedSup: {},
      loading: true,
      contact: {
        name: '',
        mail: '',
        number: '',
        positions: [],
      },
      dataSource: [],
      supplier: {
        mailing_address_input: false,
        ico: '',
        dic: '',
        name: '',
        street: '',
        zip: '',
        district: '',
        account: '',
        mailing_address: {
          street: '',
          zip: '',
          district: '',
        }
      },
      paginationLocale: {
        items_per_page: '/ stránce',
        jump_to: 'Přejít na',
        jump_to_confirm: 'Potvrdit',
        page: '',
        prev_page: 'Předchozí stránka',
        next_page: 'Další stránka',
        prev_5: 'Předchozích 5 stránek',
        next_5: 'Dalších 5 stránek',
        prev_3: 'Předchozí 3 stránky',
        next_3: 'Další 3 stránky',
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 2,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} z ${total} položek`,
        onChange: this.handlePaginationChange,
        onShowSizeChange: this.handlePaginationChange,
      },
    };
  },
  computed: {
    filteredData() {
      if (!this.searchValue) {
        return this.dataSource
      }
      const filterTextLower = this.searchValue.toLowerCase();
      return this.dataSource.filter(item => {
        return Object.keys(item).some(key => {
          return String(item[key]).toLowerCase().includes(filterTextLower);
        });
      });
    },
    isUserSuperadmin() {
      return this.$store.getters['UserModule/user'].role === 'Superadmin'
    },
    isMobileView() {
      return this.$store.getters['isMobileView']
    },
    columns() {
      if (this.isMobileView) {
        return [
          {
            title: '',
            dataIndex: 'all',
            key: 'all'
          }
        ]
      }
      return [
        {
          title: this.$t('supplier'),
          dataIndex: 'name',
          key: 'name',
          width: 200,
        },
        {
          title: 'IČO',
          dataIndex: 'ico',
          key: 'ico',
        },
        {
          title: 'DIČ',
          dataIndex: 'dic',
          key: 'dic',
        },
        {
          title: this.$t('residence'),
          dataIndex: 'address',
          key: 'address',
        },
        {
          dataIndex: 'action',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: 150
        },
      ]
    }
  },
  async mounted() {
    if (this.$route.query.page) {
      this.pagination.current = +this.$route.query.page
    }
    if(this.$route.query.pageSize) {
      this.pagination.pageSize = +this.$route.query.pageSize;
    }
    await this.getSupsList()
  },
  methods: {
    deleteHandler() {
      if (this.$store.getters['UserModule/user']?.user_permissions?.find(p => p.codename === 'delete_supplier')) {
        this.showDeleteSubModal = true
      } else if (this.isUserSuperadmin) {
        this.showDeleteSubModal = true
      } else {
        notification.error({
          message: this.$t('notifications.error'),
          description: this.$t('no-permission'),
        })
      }
    },
    addSupplierHandler() {
      if (this.$store.getters['UserModule/user']?.user_permissions?.find(p => p.codename === 'add_supplier')) {
        this.showAddModal = true
      } else if (this.isUserSuperadmin) {
        this.showAddModal = true
      } else {
        notification.error({
          message: this.$t('notifications.error'),
          description: this.$t('no-permission'),
        })
      }
    },
    async getSupsList() {
      try {
        const path = this.$route.path;
        const { current, pageSize } = this.pagination;
        if(!this.$route.query.pageContact) {
          await this.$router.push({ path, query: { page: current, pageSize: pageSize} });
        }

        const {data} = await this.$store.dispatch('Suppliers/getSupsList', {
          page_size: this.pagination.pageSize,
          page: this.pagination.current
        })
        this.dataSource = data.results
        this.loading = false
        this.pagination.current = data.current
        this.pagination.pageSize = data.page_size
        this.pagination.total = data.count
      } catch (e) {
        notification.error({
          message: this.$t('notifications.error'),
          description: e.response.data.errors[0].detail,
        })
      }

    },
    handlePaginationChange(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getSupsList();
    },
    handleActionClick(record) {
      this.selectedSup = record
    },
    async handleOkAdd(companyData) {
      try {
        await this.$store.dispatch('Suppliers/createSupplier', companyData)
        this.showAddModal = false
        await notification.success({
          message: this.$t('notifications.success'),
          description: this.$t('notifications.sup-created'),
        })
        setTimeout(() => {
          window.location.reload()
        }, 700)

      } catch(e) {
        console.log(e)
        notification.error({
          message: this.$t('notifications.error'),
          description: e.response.data.errors[0].detail,
        })
      }
    },
    handleCancelAdd() {
      this.showAddModal = false
    },
    async handleOkDelete() {
      try {
        await this.$store.dispatch('Suppliers/deleteSupplier', this.selectedSup.uid)
        await notification.success({
          message: this.$t('notifications.success'),
          description: this.$t('notifications.sup-deleted'),
        })
        this.showDeleteSubModal = false
        setTimeout(() => {
          window.location.reload()
        }, 700)
      } catch(e) {
        notification.error({
          message: this.$t('notifications.error'),
          description: e.response.data.errors[0].detail,
        })
      }
    },
    handleCancelDelete() {
      this.showDeleteSubModal = false
    },
    openShowContactModal(record) {
      if (this.$store.getters['UserModule/user']?.user_permissions?.find(p => p.codename === 'change_contact' && p.id === 69)) {
        this.contact = record
        this.showContactModal = true
      } else if (this.isUserSuperadmin) {
        this.contact = record
        this.showContactModal = true
      } else {
        notification.error({
          message: this.$t('notifications.error'),
          description: this.$t('no-permission'),
        })
      }
    },
    async handleOkContact(contact) {
      try {
        await this.$store.dispatch('Suppliers/updateContact', {
          uid: contact.uid,
          data: contact
        })
        this.showContactModal = false
        await notification.success({
          message: this.$t('notifications.success'),
          description: this.$t('notifications.contact-updated'),
        })
        setTimeout(() => {
          window.location.reload()
        }, 700)

      } catch (e) {
        notification.error({
          message: this.$t('notifications.error'),
          description: e.response.data.errors[0].detail,
        })
      }
    },
    handleCloseContact() {
      this.showContactModal = false
      this.contact = {}
    },
    customRow(record) {
      return {
        onClick: () => {
          const slug = record.uid
          this.$router.push({ name: "SupplierDetail", params: { slug } })
        },
      };
    },
    async exportData() {
      if (this.$store.getters['UserModule/user']?.user_permissions?.find(p => p.codename === 'export_supplier')) {
        try {
          const {data} = await this.$store.dispatch('Suppliers/exportData', {
            suppliers_uids: this.dataSource.map(s => s.uid)
          })

          window.open(data?.url, "_blank");
        } catch (e) {
          notification.error({
            message: this.$t('notifications.error'),
            description: e.response.data.errors[0].detail,
          })
        }
      } else if (this.isUserSuperadmin) {
        try {
          const {data} = await this.$store.dispatch('Suppliers/exportData', {
            suppliers_uids: this.dataSource.map(s => s.uid)
          })
          window.open(data?.url, "_blank");
        } catch (e) {
          notification.error({
            message: this.$t('notifications.error'),
            description: e.response.data.errors[0].detail,
          })
        }
      }

      else {
        notification.error({
          message: this.$t('notifications.error'),
          description: this.$t('no-permission'),
        })
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/inputs.scss";
@import "~@/assets/scss/components/table-styles.scss";

.subs-wrap {
  padding: 3rem 40px 0;
  .subs-head {
    display: flex;
    align-items: center;
    gap: 10px;

    @media (max-width: 800px) {
      flex-direction: column;
    }
  }
}

</style>
